let TabTireSearch = {
    vehicleInfo: {},

    init: function (tabs = {}) {
        //determine the first tab pane to show
        jQuery('#tab-tire-search li:first-child a').tab('show');
        jQuery('#tab-tire-search li:first-child a i.fa-minus').addClass('active');
        jQuery('#tab-tire-search li').not(':first-child').find('a i.fa-plus').addClass('active');
    
        //rip out the tab name from each object key with split, then build the name of the event hookup function to call and call it
        //only the tabs that need events will have functions for them, so only call the function if it exists
        Object.keys(tabs).forEach(t => {
            let fnName = t.split('_')[1].toString() + 'SearchEvents';
            if (TabTireSearch[fnName]) {
                TabTireSearch[fnName]();
            }
        });

        TabTireSearch.vehicleInfo = JSON.parse(Util.getCookie('vehicle_info')) || {};
        let [initSelectName] = Object.keys(TabTireSearch.vehicleInfo);
        if (initSelectName) jQuery(`[name=${initSelectName}]`).val(TabTireSearch.vehicleInfo[initSelectName]).change();
    },

    //hook up events for searching by vehicle
    vehicleSearchEvents: function () {
        jQuery('#vehicle-year').on('change', function () {
            //clear all lower levels when changing this level
            let makeSelect = jQuery('#vehicle-make');
            TabTireSearch.resetSelect(makeSelect);
            TabTireSearch.resetSelect(jQuery('#vehicle-model'));
            TabTireSearch.resetSelect(jQuery('#vehicle-option'));
            TabTireSearch.resetSelect(jQuery('#vehicle-tiresize'));
    
            let queryParams = {
                'year': this.value
            }; 
    
            let selectName = jQuery(this).attr('name');
            let shouldAutoFill = TabTireSearch.vehicleInfo[selectName] == this.value
    
            TabTireSearch.updateSelect('vehicle/makes', queryParams, makeSelect, null, shouldAutoFill);
        });

        jQuery('#vehicle-make').on('change', function () {
            //clear all lower levels when changing this level
            let modelSelect = jQuery('#vehicle-model');
            TabTireSearch.resetSelect(modelSelect);
            TabTireSearch.resetSelect(jQuery('#vehicle-option'));
            TabTireSearch.resetSelect(jQuery('#vehicle-tiresize'));
    
            let queryParams = {
                'year': jQuery('#vehicle-year').val(),
                'make': this.value
            };        
    
            let selectName = jQuery(this).attr('name');
            let shouldAutoFill = TabTireSearch.vehicleInfo[selectName] == this.value
    
            TabTireSearch.updateSelect('vehicle/models', queryParams, modelSelect, null, shouldAutoFill);
        });

        jQuery('#vehicle-model').on('change', function () {
            //clear all lower levels when changing this level
            let optionSelect = jQuery('#vehicle-option');
            TabTireSearch.resetSelect(optionSelect);
            TabTireSearch.resetSelect(jQuery('#vehicle-tiresize'));
    
            let queryParams = {
                'year': jQuery('#vehicle-year').val(),
                'make': jQuery('#vehicle-make').val(),
                'model': this.value
            };
    
            let selectName = jQuery(this).attr('name');
            let shouldAutoFill = TabTireSearch.vehicleInfo[selectName] == this.value
    
            TabTireSearch.updateSelect('vehicle/options', queryParams, optionSelect, 'Option', shouldAutoFill);
        });

        jQuery('#vehicle-option').on('change', function () {
            //clear all lower levels when changing this level
            let tireSizeSelect = jQuery('#vehicle-tiresize');
            TabTireSearch.resetSelect(tireSizeSelect);
            TabTireSearch.resetSelect(jQuery('#vehicle-tiresize'));

            let queryParams = {
                'year': jQuery('#vehicle-year').val(),
                'make': jQuery('#vehicle-make').val(),
                'model': jQuery('#vehicle-model').val(),
                'options': this.value.replace('"', '\\"')
            };
    
            let selectName = jQuery(this).attr('name');
            let shouldAutoFill = TabTireSearch.vehicleInfo[selectName] == this.value
    
            TabTireSearch.updateSelect('vehicle/sizes', queryParams, tireSizeSelect, null, shouldAutoFill);
        });
    },

    sizeSearchEvents: function () {
        jQuery('#size-section-width').on('change', function () {
            //clear all lower levels when changing this level
            let aspectRatioSelect = jQuery('#size-aspect-ratio');
            TabTireSearch.resetSelect(aspectRatioSelect);
            TabTireSearch.resetSelect(jQuery('#size-rim-size'));

            let queryParams = {
                'width': this.value
            };

            TabTireSearch.updateSelect('tireaspects', queryParams, aspectRatioSelect, null);
        });

        jQuery('#size-aspect-ratio').on('change', function () {
            //clear all lower levels when changing this level
            let rimSizeSelect = jQuery('#size-rim-size');
            TabTireSearch.resetSelect(rimSizeSelect);

            let queryParams = {
                'width': jQuery('#size-section-width').val(),
                'ratio': this.value
            };

            TabTireSearch.updateSelect('tirerims', queryParams, rimSizeSelect, null);
        });
    },

    resetSelect: function (select) {
        select.attr('disabled', true);
        select.find('option').not(':first').remove(); //leave the first option with the name of the select
        select.children()[0].selected = true;
    },

    //retreive data from the endpoint to populate targetSelect with
    //queryParams are used to get the correct data from the endpoint, dataProperty is the value coming back in the response object
    updateSelect: function (endpoint, queryParams, targetSelect, dataProperty, shouldAutoFill) {
        //lock all enabled selects so the user can't change them while the ajax request is pending
        //lock the find button as well to prevent submitting an incomplete form
        let unlocked = jQuery('#tab-tire-search-wrapper').find('select:enabled, button');
        unlocked.attr('disabled', true);

        jQuery.ajax({
            url: Util.lambdaHost + endpoint,
            beforeSend: function (request) {
                request.setRequestHeader('x-api-key', Util.lambdaApiKey);
            },
            type: 'GET',
            data: queryParams,
            success: function (response) {
                // sort response values for make, model, option and size selects
                response.sort();
                if (response.length === 1) jQuery(targetSelect).find('option').removeAttr("selected");
                if (dataProperty) {
                    jQuery.each(response, function (index, item) {
                        targetSelect.append(new Option(item[dataProperty], item[dataProperty]));
                    });
                } else {
                    jQuery.each(response, function (index, item) {
                        targetSelect.append(new Option(item, item));
                    });
                }

                targetSelect.removeAttr('disabled');
                let targetName = targetSelect.attr('name');

                if (shouldAutoFill && TabTireSearch.vehicleInfo[targetName]) {
                    //fill form using previous search vehicle info
                    jQuery(targetSelect).val(TabTireSearch.vehicleInfo[targetName]).change();
                } else if (response.length === 1) {
                    jQuery(targetSelect).find('option:eq(1)').attr('selected', 'selected').trigger('change');
                }

            },
            error: function (response) {
                console.log(response);
            },
            complete: function (response) {
                //unlock the select boxes locked before the request
                unlocked.attr('disabled', false);
            }
        });
    },

    //save user vehicle info as cookie for later searches
    handleVehicleTabFormSubmit: function () {
        //remove hidden inputs
        let vehicleInfo = jQuery('#vehicle form')
            .serializeArray()
            .slice(2)
            .reduce((acc, {
                name,
                value
            }) => ({
                ...acc,
                [name]: value
            }), {});

        Util.setCookie('vehicle_info', JSON.stringify(vehicleInfo))
    },

    //used to redirect users to tire brand pages
    handleBrandTabFormSubmit: function () {
        //redirect user to selected tire brand page
        location.href = '/tiremake/' + jQuery('#tire-brand').val().toLowerCase();

        //prevent form submit
        return false;
    },
    handleModelTabFormSubmit: function () {
        let tireModel = jQuery('#tire-model').val();
        // Sanitize url.  Replaces spaces and forward slashes with hyphens
        tireModel = tireModel
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[\/]+/g, '-')

        location.href += `/${tireModel}`;

        //prevent form submit
        return false;
    }
};